<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'Dashboard',
  computed: {
    ...mapState('stats/dashboard', [
      'item',
    ]),
  },
  methods: {
    ...mapActions('stats/dashboard', [
      'fetch',
    ]),
    ...mapMutations('ui', [
      'setSearch',
    ]),
  },
  created() {
    this.fetch();
    this.setSearch({
      placeholder: 'Enter at least 2 characters to search courses by title',
      route: 'courses-listing',
    });
  },
};
</script>
<style lang="scss" scoped>

</style>
<template>
  <div>
    <div class="row">
      <div class="col-4">
        <div class="box d-flex flex-column text-center">
          <h2>{{ item.totalCourses || 0 }}</h2>
          <h5>Total Courses</h5>
        </div>
      </div>
      <div class="col-4">
        <div class="box d-flex flex-column text-center">
          <h2>{{ item.totalUsedCodes || 0 }} / {{ item.totalActiveCodes || 0 }} </h2>
          <h5>Used / Active Codes</h5>
        </div>
      </div>
      <!-- <div class="col-4">
        <div class="box d-flex flex-column text-center">
          <h2>{{ item.totalUsedInvitations || 0 }} / {{ item.totalActiveInvitations || 0 }}</h2>
          <h5>Used / Active Invitations</h5>
        </div>
      </div> -->
    </div>
    <ul class="mt-5">
      <li v-for="(course, index) in item.courseCodes" :key="index" class="mb-3">
        <div class="box d-flex justify-content-between">
          <router-link :to="{ name: 'courses-edit', params: { id: course.id }}">{{ course.title }}</router-link>
          <span>{{ course.codes.used }} out of {{ course.codes.total }} were used</span>
        </div>
      </li>
    </ul>
  </div>
</template>
